<style scope>
  .w-full { width: 100% }
</style>

<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    <b-table :data="lista" :loading="loading" class="row-click"
             :paginated="true" detailed>
      <portal-lista-vazia slot="empty"/>

      <template slot-scope="props">
        <b-table-column label="Pedido">
          {{ props.row.CODIGO }}
        </b-table-column>

        <b-table-column label="Código Web">
          {{ props.row.CODIGOWEB }}
        </b-table-column>

        <b-table-column label="Cliente">
          {{ props.row.cliente.A1_NOME }}
        </b-table-column>

         <b-table-column label="Origem">
          <div v-if="props.row.ORIGEM_CLIENTE === 'B'">
            Cliente da Base
          </div>
          <div v-else-if="props.row.ORIGEM_CLIENTE === 'I'">
            Base de Inativo
          </div>         
        </b-table-column>

        <b-table-column label="Data Emissão">
          {{ props.row.DT_EMISSAO ? new Date(props.row.DT_EMISSAO).toLocaleDateString() : ' - ' }}
        </b-table-column>

        <b-table-column label="Data Entrega">
          {{ props.row.DT_ENTREGA ? new Date(props.row.DT_ENTREGA).toLocaleDateString() : ' - ' }}
        </b-table-column>

        <b-table-column label="Descontos" :visible="parametros.PERMITE_DESC_CABECALHO === 'S'">
          <b-tag v-if="props.row.descontos">{{props.row.descontos}}</b-tag>
          <!--<b-tag>{{props.row.DESC1}}%</b-tag>-->
          <!--<b-tag>{{props.row.DESC2}}%</b-tag>-->
          <!--<b-tag v-if="parametros.DESCONTO_3_VISIVEL ==='S'">{{props.row.DESC3}}%</b-tag>-->
          <!--<b-tag>{{props.row.DESC4}}%</b-tag>-->
        </b-table-column>

        <b-table-column label="Total">
          {{ props.row.VALOR_WEB | moeda }}
        </b-table-column>

        <b-table-column label="Status" >
          <b-tag type="is-info" v-if="props.row.STATUS === 'E'">Sincronizado</b-tag>
          <b-tag type="is-danger" v-if="props.row.STATUS === 'A'">Sincronizando...</b-tag>
          <b-tag type="is-success" v-if="props.row.STATUS === 'P'">APROVADO</b-tag>
          <b-tag type="is-warning" v-if="props.row.STATUS && props.row.STATUS.length > 1 ">
            {{props.row.STATUS}}
          </b-tag>

        </b-table-column>

        <b-table-column label="" :visible="props.row.CODIGO !== null">
          <button class="button is-small" @click="downloadPedido(props.row.CODIGO)"
                  title="Download">
            <b-icon icon="file-pdf"/>
          </button>
        </b-table-column>

      </template>

      <template slot="detail" slot-scope="props">
        <table class="table is-fullwidth m-t-sm" v-if="props.row.itens.length > 0">
          <tr>
            <th>Item</th><th>Código</th><th>Descrição</th> <th>Qtd</th> <th>Valor tabela</th><th>Valor venda</th>
            <th v-if="parametros.PERMITE_DESC_ITEM === 'S'">Desconto(%)</th><th>Comissão(%)</th><th>Total do Item</th>
          </tr>
          <tr v-for="(item,i) in props.row.itens" :key="i">
            <td>{{ item.NUMITEM }}</td>
            <td>{{ item.COD_ITEM }}</td>
            <td>{{ item.DESCRICAO }}</td>
            <td>{{ item.QUANT }}</td>
            <td>{{ item.VALOR_TABELA | moeda}}</td>
            <td>{{ item.VALOR_VENDA | moeda}}</td>
            <td class="is-numeric" v-if="parametros.PERMITE_DESC_ITEM === 'S'">
              {{item.DESCONTO_TOTAL }}%
            </td>
            <td class="is-numeric">
              {{ item.COMISSAO_ITEM }}%
            </td>
            <td>{{ item.VALOR_TOTAL | moeda }}</td>
          </tr>
        </table>
      </template>

    </b-table>
  </div>
</template>

<script>
  export default {
    props: ['lista', 'loading', 'parametros'],
    data () {
      return {
        isLoading: false
      }
    },
    methods: {
      downloadPedido (codigo) {
        this.isLoading = true
        this.$http({
          method: 'get',
          url: this.$URL.DOWNLOAD.PEDIDO + codigo,
          responseType: 'arraybuffer'
        })
          .then(response => {
            // console.log(response.data)
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'PEDIDO_' + codigo + '.pdf')
            document.body.appendChild(link)
            link.click()
            this.isLoading = false
          })
          .catch((response) => {
            this.$toast.open({
              message: 'Não foi possível localizar o pedido para download.',
              type: 'is-danger',
              duration: 4 * 1000
            })
            this.isLoading = false
          })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/pedido/ListaPortal.vue